export interface SettingsState {
  communicationPreferences: string[]
  modules: string[]
}

export const initialSettingsState: SettingsState = {
  communicationPreferences: [],
  modules: []
}
